import styled from "styled-components";

export const Paragraph = styled.p`
    font-size: 16px;
    font-weight: 500;
    line-height: 26.5px;
`;